import NavBarType03 from 'components/customs/NavBarType03'
import Footer from 'components/defaults/Footer'
import React from 'react'
import {Outlet} from 'react-router-dom'

const Root = () => {
  return (
    <div className='bg-little-gray'>
      <NavBarType03 />
      <Outlet />
      <div className='flex-auto min-h-0 '></div>
      <Footer />
    </div>
  )
}

export default Root
